import { DomainDisasterRecovery } from '@wanxin-site/common-utils';
import { getEnv } from '@/apis/heziShare';
import { md5Str } from "@/libs/axios";
import { getWxBoxHost } from '@/apis/wxActivity';
import { getBtBoxEnv, getBtBoxHost } from '@/apis/btBoxActivity';

const defaultWxBoxHostList = {
  dev: [
    { url: 'https://wxboxtest.hzwxbz9991.cn', status: 1 },
    { url: 'https://wxboxtest.wxbzwl.cn', status: 1 },
  ],
  pre: [
    { url: 'https://wxboxpre.hzwxbz999.cn', status: 1 },
    { url: 'https://wxboxpre.wxbzwl.cn', status: 1 },
  ],
  prod: [
    { url: 'https://wxbox.hzwxbz2.cn', status: 1 },
    { url: 'https://wxbox.wanxingame.cn', status: 1 },
    { url: 'https://wxbox.wxbz77.cn', status: 1 }
  ]
}

// 1. 创建域名容灾实例 - wxBox 盒子
export const wxBoxDomainManager = new DomainDisasterRecovery({
  projectId: 'wxBox', // 项目标识
  envDomains: {
    dev: defaultWxBoxHostList.dev,
    pre: defaultWxBoxHostList.pre,
    prod: defaultWxBoxHostList.prod
  },
  storagePrefix: 'host_cache', // 与原有存储key保持一致
  envMapping: {
    dev: defaultWxBoxHostList.dev.map(item => item.url),
    pre: defaultWxBoxHostList.pre.map(item => item.url)
  },
  getCurrentEnv: () => {
    console.log('getCurrentEnv', process.env.VUE_APP_ENV)
    return process.env.VUE_APP_ENV;
  }
});

const defaultBtBoxHostList = {
  dev: [
    { url: 'https://btboxtest.hzwxbz9992.cn', status: 1 },
    { url: 'https://btboxtest.wxbzwl.cn', status: 1 },
  ],
  pre: [
    { url: 'https://btboxpre.hzwxbz999.cn', status: 1 },
    { url: 'https://btboxpre.wxbzwl.cn', status: 1 },
  ],
  prod: [
    { url: 'https://bthezi.hzwxbz3.cn', status: 1 },
    { url: 'https://bthezi.wanxingame.cn', status: 1 },
    { url: 'https://bthezi.wxbz77.cn', status: 1 }
  ]
}

// 1. 创建域名容灾实例 - btBox 盒子
export const btBoxDomainManager = new DomainDisasterRecovery({
  projectId: 'btBox', // 项目标识
  envDomains: {
    dev: defaultBtBoxHostList.dev,
    pre: defaultBtBoxHostList.pre,
    prod: defaultBtBoxHostList.prod
  },
  storagePrefix: 'host_cache', // 与原有存储key保持一致
  envMapping: {
    dev: defaultBtBoxHostList.dev.map(item => item.url),
    pre: defaultBtBoxHostList.pre.map(item => item.url)
  },
  getCurrentEnv: () => {
    console.log('getCurrentEnv', process.env.VUE_APP_ENV)
    return process.env.VUE_APP_ENV;
  }
});

export const initHostDisasterRecovery = () => {
  const now = Date.now()
  const type = '2'
  const tk = md5Str(now + type + 'BoX2URlKeY')
  wxBoxDomainManager.updateHostList(getWxBoxHost, {
    time: now,
    type: type,
    token: tk,
  }, (res) => {
    const { data } = res || {}
    const { main } = data || {}
    wxBoxDomainManager.insertTrustedHost(main)
  })

  btBoxDomainManager.updateHostList(getBtBoxHost, {
    time: now,
    type: type,
    token: tk,
  }, (res) => {
    const { data } = res || {}
    const { main } = data || {}
    btBoxDomainManager.insertTrustedHost(main)
  })
}

export const getCurrentHost = (config) => {
  const wxUrl = getEnv()
  if (config && config.url.startsWith(wxUrl)) {
    config.url = config.url.replace(wxUrl, '')
    return wxBoxDomainManager.getCurrentHostUrl()
  }
  const btUrl = getBtBoxEnv()
  if (config && config.url.startsWith(btUrl)) {
    config.url = config.url.replace(btUrl, '')
    return btBoxDomainManager.getCurrentHostUrl()
  }
  return null
};
